const replaceTagName = (element, tagName) => {
  if (!element || element.tagName.toLowerCase() === tagName.toLowerCase()) {
    return element;
  }

  const replacement = document.createElement(tagName);

  Array.from(element.attributes).forEach((attribute) => {
    replacement.setAttribute(attribute.name, attribute.value);
  });

  while (element.firstChild) {
    replacement.appendChild(element.firstChild);
  }

  element.replaceWith(replacement);

  return replacement;
};

const normalizeHeadingOrder = () => {
  const heroLead = document.querySelector('h3.kt-adv-heading19_2b5e2b-e1');

  if (!heroLead) {
    return;
  }

  replaceTagName(heroLead, 'h2');
};

const normalizeSplideRoles = (root = document) => {
  root
    .querySelectorAll('.splide__list[role="presentation"]')
    .forEach((list) => {
      if (list.getAttribute('role') !== 'list') {
        list.setAttribute('role', 'list');
      }
    });

  root
    .querySelectorAll('li.splide__slide[role][aria-roledescription="slide"]')
    .forEach((slide) => {
      if (slide.getAttribute('role') !== 'listitem') {
        slide.setAttribute('role', 'listitem');
      }
    });
};

export const initStructuralA11y = () => {
  normalizeHeadingOrder();
  normalizeSplideRoles();

  if (document.body?.dataset.a11yStructuralObserverReady === 'true') {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        if (
          mutation.target.matches('.splide__list[role="presentation"], li.splide__slide[role]')
        ) {
          normalizeSplideRoles(mutation.target.parentElement || document);
        }

        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches?.('h3.kt-adv-heading19_2b5e2b-e1')) {
          replaceTagName(node, 'h2');
          return;
        }

        if (node.matches?.('li.splide__slide[role="group"][aria-roledescription="slide"]')) {
          node.setAttribute('role', 'listitem');
        }

        normalizeSplideRoles(node);
      });
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['role'],
    childList: true,
    subtree: true,
  });

  document.body.dataset.a11yStructuralObserverReady = 'true';
};
